<template>
  <div class="myTemplate">
    <div class="search">
      <div class="radio-group">
        <div
          v-for="item in menus"
          :key="item.id"
          class="custom-radio-card"
          :class="{ 'custom-radio-card-checked': templateType === item.id }"
          @click="changeTemplateType(item.id)"
        >
          <div class="custom-radio-card-title">{{ $t(item.name) }}</div>
        </div>
      </div>
      <a-input-search
        v-model="keyword"
        class="search-input"
        enter-button
        @change="getTemplate()"
        :placeholder="$t('project.inputSearchKeywords')"
        style="width: 300px"
      />
    </div>
    <div class="filter">
      <div class="filterLeft">
        <a-select
          v-model="comprehensiveValue"
          allowClear
          class="filterSelect"
          :placeholder="$t('project.comprehensive')"
          style="width: 150px; margin-left: 0px"
        >
          <a-select-option v-for="(item, index) in comprehensiveOptions" :value="item.id" :key="index">
            {{ $t(item.name) }}
          </a-select-option>
        </a-select>
        <a-select
          v-model="industryValue"
          allowClear
          class="filterSelect"
          :placeholder="$t('project.industry')"
          style="width: 150px"
        >
          <a-select-option v-for="(item, index) in industryOptions" :key="index" :value="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-range-picker
          class="filterSelect"
          format="YYYY-MM-DD"
          style="width: 270px; height: 32px"
          @change="onChange"
        />
      </div>
      <div class="filterRight">
        <div class="iconBox">
          <img src="@/assets/images/refreshIcon.png" alt="" @click="refreshList()" style="margin-right: 8px" />
          <img v-if="changeListFlag" src="@/assets/images/table_list.png" class="icon" @click="changeList()" />
          <img v-else src="@/assets/images/menuIcon.png" class="icon" alt="" @click="changeList()" />
        </div>
      </div>
    </div>
    <div class="listTable project-kind-list">
      <CardList
        v-if="changeListFlag"
        :data-list="dataList"
        :del-handle="delHandle"
        :preview-handle="previewHandle"
        :pageTotal="pageTotal"
        :loadDataFunc="getTemplate"
        cardType="template"
        class="cardList"
      />
      <div v-else class="listTable">
        <a-table
          :selectedRowKeys="selectedKeys"
          :bordered="false"
          :columns="columns"
          :dataSource="dataList"
          :pagination="pagination"
          :rowSelection="rowSelection"
          :rowKey="(record) => record.id"
        >
          <template slot="action" slot-scope="text, record">
            <AuthControl code="preview_template_web">
              <a class="button-link" v-show="isShowBtn(record.itemStatus, 'preview')" @click="previewHandle(record)">
                {{ $t('project.preview') }}
              </a>
            </AuthControl>
            <AuthControl code="del_template_web">
              <a
                class="button-link"
                v-show="isShowBtn(record.itemStatus, 'del')"
                @click="delHandle(record)"
                style="color: #ff4d4f">
                {{ $t('project.delete') }}
              </a>
            </AuthControl>
          </template>
          <template slot="coverUrl" slot-scope="text, record">
            <img :src="imgHost + record.coverUrl" alt="img" class="hover-mask" />
          </template>
          <template slot="itemStatus" slot-scope="text, record">
            <a-badge :status="statusColor[record.itemStatus]" />
            {{ record.itemStatus }}
          </template>
        </a-table>
      </div>
    </div>

    <a-modal :visible="delVisible" :title="$t('project.informationTip')" @cancel="handleCancel" @ok="delHandleOk" :titleAlign="'start'">
      <div>
        <a-icon type="exclamation-circle" style="color: orange" />
        {{ $t('tip.confirmDelete') }}
      </div>
    </a-modal>

    <a-modal :visible="previewVisible" :footer="null" :title="$t('project.previewTemplate')" :width="1550" @cancel="handlePreviewCancel">
      <PreviewTemplate v-if="previewVisible" :previewData="previewData" type="template" />
    </a-modal>
  </div>
</template>

<script>
import { getTemplatePage, cancelPublish } from '@/api/myTemplate'
import { selectAllIndustries } from '@/api/projectModelApi'
import CardList from './templateCard.vue'
import PreviewTemplate from './previewTemplate.vue'
import { Modal } from 'ant-design-vue'

export default {
  name: 'MyTemplate',
  components: {
    CardList,
    PreviewTemplate,
  },
  props: {
    projectInfo: {
      type: Object,
      default: () => ({}),
    },
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      templateType: '1',
      keyword: '',
      timeRange: [],
      comprehensiveValue: undefined,
      comprehensiveOptions: [
        { id: 'publishTime', name: 'project.latestRelease' },
        { id: 'collectCnt', name: 'project.hotRecommend' },
        { id: 'downloadCnt', name: 'project.mostUsed' },
        { id: 'browseCnt', name: 'project.mostBrowsed' },
      ],
      menus: [
        { id: '0', name: 'project.electronicSandbox' },
        { id: '1', name: 'project.projectScheme' },
        { id: '2', name: 'project.processSimulation' },
      ],
      statusValue: undefined,
      statusOptions: [
        { id: '0', name: 'project.uploadSuccess' },
        { id: '1', name: 'project.pendingReview' },
        { id: '2', name: 'project.sold' },
        { id: '3', name: 'project.reviewNotPassed' },
        { id: '-1', name: 'project.soldOff' },
        { id: '-2', name: 'project.unknownStatus' },
      ],
      industryValue: undefined,
      industryOptions: [],
      imgHost: process.env.VUE_APP_CTYUN_URL,
      previewData: {},
      delTemplate: {},
      dataList: [],
      selectedKeys: [],
      delVisible: false,
      previewVisible: false,
      changeListFlag: true,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      statusColor: {
        'project.pendingReview': 'warning',
        'project.sold': 'success',
        'project.reviewNotPassed': 'warning',
        'project.soldOff': 'normal',
      },
      pageTotal: 0,
    }
  },
  computed: {
    rowSelection() {
      return {
        type: 'checkbox',
        showCheckedAll: true,
        onlyCurrent: false,
      }
    },
    columns() {
      return [
        {
          title: this.$t('project.serialNumber'),
          width: 140,
          dataIndex: 'index',
        },
        {
          title: this.$t('project.templateName'),
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: this.$t('project.preview'),
          scopedSlots: { customRender: 'coverUrl' },
          width: 300,
          align: 'center',
        },
        {
          title: this.$t('project.version'),
          align: 'center',
          dataIndex: 'version',
        },
        {
          title: this.$t('project.status'),
          scopedSlots: { customRender: 'itemStatus' },
          align: 'center',
        },
        {
          title: this.$t('project.uploadTime'),
          dataIndex: 'publishTime',
          width: 300,
          align: 'center',
        },
        {
          title: this.$t('project.operations'),
          scopedSlots: { customRender: 'action' },
          width: 150,
          align: 'center',
        },
      ]
    },
  },
  watch: {
    templateType: {
      handler(newValue) {
        this.getTemplate()
      },
    },
    comprehensiveValue: {
      handler(newValue) {
        this.getTemplate()
      },
    },
    industryValue: {
      handler(newValue) {
        this.getTemplate()
      },
    },
  },
  created() {
    this.getIndustryList()
    this.getTemplate()
  },
  methods: {
    // 获取行业数据
    getIndustryList() {
      selectAllIndustries().then((res) => {
        if (res.status === 0) {
          this.industryOptions = res.data
          localStorage.setItem('getIndustryList', JSON.stringify(res.data))
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getTemplate(pageNo = 1, pageSize = 10) {
      const params = {
        keyword: this.keyword,
        itemStatus: this.statusValue,
        type: this.templateType,
        industry: this.industryValue,
        startPublishDate: this.timeRange.length ? this.timeRange[0] : '',
        endPublishDate: this.timeRange.length ? this.timeRange[1] : '',
        tempalteIds: [],
        sourceIds: [],
        // userId: null,
        valid: null,
        pageNo,
        pageSize,
        orderField: this.comprehensiveValue || 'publishTime',
        orderType: 'desc',
      }
      getTemplatePage(params).then((res) => {
        if (res.status === 0) {
          this.dataList = res.data.data
          this.dataList.forEach((item, index) => {
            item.index = index + 1
            item.itemStatus =
              Number(item.itemStatus) === 0
                ? 'project.uploadSuccess'
                : Number(item.itemStatus) === 1
                ? 'project.pendingReview'
                : Number(item.itemStatus) === 2
                ? 'project.sold'
                : Number(item.itemStatus) === 3
                ? 'project.reviewNotPassed'
                : Number(item.itemStatus) === -1
                ? 'project.soldOff'
                : 'project.unknownStatus'
          })
          this.pageTotal = res.data.count
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onChange(dateString, date) {
      this.timeRange = dateString || []
      this.getTemplate()
    },
    refreshList() {
      this.statusValue = undefined
      this.comprehensiveValue = undefined
      this.industryValue = undefined
      this.timeRange = []
      this.getTemplate()
    },
    changeList() {
      this.changeListFlag = !this.changeListFlag
    },
    isShowBtn(status, type) {
      if (type === 'preview') {
        switch (status) {
          case 'project.pendingReview':
            return true
          case 'project.sold':
            return true
          case 'project.reviewNotPassed':
            return true
          case 'project.soldOff':
            return false
          default:
            return false
        }
      } else {
        switch (status) {
          case 'project.pendingReview':
            return true
          case 'project.sold':
            return false
          case 'project.reviewNotPassed':
            return true
          case 'project.soldOff':
            return true
          default:
            return false
        }
      }
    },
    delHandle(item) {
      console.log('删除', item)
      this.delTemplate = item
      this.delVisible = true
    },
    previewHandle(item) {
      this.previewVisible = true
      this.previewData = item
    },
    delHandleOk() {
      this.delVisible = false
      const params = {
        id: this.delTemplate.id,
      }
      cancelPublish(params).then((res) => {
        if (res.status === 0) {
          Modal.success({
            title: this.$t('project.deleteSuccess'),
            content: '',
          })
          this.getTemplate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCancel() {
      this.delVisible = false
    },
    handlePreviewCancel() {
      this.previewVisible = false
    },
    changeTemplateType(id) {
      this.templateType = id
    },
  },
}
</script>
<style lang="less">
.ant-layout {
  &::-webkit-scrollbar {
    display: block;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    transition: background 0.3s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.4);
  }
}
</style>
<style lang="less" scoped>
.myTemplate {
  display: flex;
  flex-direction: column;
  //padding: 0 16px;
  // 自定义滚动条样式
  .search,
  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    .radio-group {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .search-input {
      width: 300px;
    }
  }

  .filter {
    //height: 5%;
    //background-color: rgba(62, 86, 93, 0.3);
    .filterLeft,
    .filterRight {
      //width: 48%;
      //height: 100%;
      display: flex;
    }

    .filterLeft {
      display: flex;
      justify-content: space-between;
      align-items: center;
      //background: #00081c;
      padding: 5px;
      // width: 40%;

      .filterSelect {
        width: 120px;
        margin: 0 10px;
      }
    }

    .filterRight {
      width: 25%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .iconBox {
        padding: 5px;
        cursor: pointer;
      }

      .icon {
        width: 24px;
        height: 24px;
        // margin: 0 5px;
        // cursor: pointer;
        // color: #999999; /* 设置图标颜色为灰色 */
      }
    }
  }

  .listTable {
    margin-top: 10px;

    .cardList {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 10px 0;
      // overflow: auto;
    }
    .hover-mask {
      width: auto;
      height: 36px;
      object-fit: cover;
      aspect-ratio: 4 / 3;
    }
    .button-link {
      margin-left: 15px;
      &::first-of-type {
        margin-left: 0;
      }
    }
    /* &-list {
       .more-card {
         width: 100%;
         margin-right: 10px;
         margin-left: 40px;
         background: var(--primary-bg-color);
         border: 1px solid var(--lv1-border-color);
         border-radius: 2px;
         cursor: pointer;
         display: flex;
         justify-content: center;
         align-items: center;

         .plus-icon {
           display: block;
           margin: 0 auto;
         }
       }
     }*/
  }
}
.custom-radio-card {
  background: #313132;
  // width: 96px;
  padding: 0 15px;
  height: 32px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c0c0c0;
  cursor: pointer;
}

.custom-radio-card-title {
  color: #fff;
  font-size: 14px;
}

.custom-radio-card-checked {
  background-color: #0166fc;
}

.custom-radio-card:hover .custom-radio-card-title,
.custom-radio-card-checked .custom-radio-card-title {
  color: #fff;
}
</style>